import { render, staticRenderFns } from "./FormCustomerAdmin.vue?vue&type=template&id=389199ae&"
import script from "./FormCustomerAdmin.vue?vue&type=script&lang=js&"
export * from "./FormCustomerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports